export default function schema([name]: TemplateStringsArray): `https://schema.org/${typeof name}` {
  return `https://schema.org/${name}`;
}
